import { createStore } from "zustand/vanilla";
import { errorToMessage } from "../errorToMessage.js";
// Clamp a reminder send hour to the valid 0–23 range (Doc 04 §6) — shared by any
// platform whose hour input is free-form rather than a fixed option list.
export const clampReminderHour = (h) => Math.min(23, Math.max(0, Math.trunc(h)));
export const createSettingsStore = (deps) => {
    // Stream subscriptions are owned by the store: dispose() unsubscribes them all, so a
    // superseded store stops writing into state nothing renders. `subs` is filled after
    // the store exists (the streams push into it).
    const subs = [];
    const store = createStore((set) => ({
        profile: null,
        settings: null,
        ready: false,
        error: null,
        save: async (patch) => {
            const r = await deps.profiles.writeProfile(patch);
            set({ error: r.ok ? null : errorToMessage(r.error) });
            return r;
        },
        dispose() {
            for (const unsubscribe of subs.splice(0))
                unsubscribe();
        },
    }));
    subs.push(deps.profiles.observeMyProfile(deps.userId).subscribe((profile) => store.setState({ profile })), deps.profiles.observeMySettings(deps.userId).subscribe((settings) => store.setState({ settings, ready: true })));
    return store;
};
//# sourceMappingURL=settingsStore.js.map